<template>
    <div class="bidding">
        <div
            class="bidding-list"
            @click="showDetails(item.localLng, item.localLat, index, item)"
        >
            <div>
                <div class="head">
                    <span class="title_name" :title="item.name"><span class="type_span">【{{ item.typeName }}】</span>{{
                        item.name
                    }}</span>
                    <span class="i-status">{{ item.distance }}</span>
                    <!-- <span
                        class="i-statusTitle"
                        :class="{ blue: item.state == 2 }"
                        >{{ item.stateName }}</span
                    > -->
                    <img class="i-statusTitle" v-if='item.state === 2' src="@/assets/jjz.png"/>
                    <img class="i-statusTitle" v-else-if='item.state === 5' src="@/assets/tpz.png"/>
                    <img class="i-statusTitle" v-else src="@/assets/jjyjs.png"/>
                </div>
                <div class="data-list">
                    <p class="end-time">
                        预算金额：
                        <span v-if="item.budgetPrice"
                            >{{ item.budgetPrice }}万元</span
                        >
                    </p>
                    <p class="end-time">
                        发布时间：
                        <span v-if="item.created">{{
                            item.created | formaHoures
                        }}</span>
                    </p>
                    <p class="end-time" v-if="item.winningName">
                        采购企业：
                        <span v-if="item.winningName">{{
                            item.winningName
                        }}</span>
                    </p>
                </div>
                <jPop
                    :type="0"
                    :item="item"
                    @inByLetDialogClick="inByLetDialogClick"
                    @go="goDetail(item.id, item.typeName)"
                ></jPop>
            </div>
        </div>
        <!-- 函询 -->
        <InByLetDialog
            :dialogVisible="inByLetDialogShow"
            :typeData="typeData"
            :dialogType="0"
            @closeDialog="closeinDialog"
            @confirmDialog="confirminDialog"
        ></InByLetDialog>
    </div>
</template>

<script>
import apiIln from '@/api/zhaocai/apiLnquiryLetter.js'
import link from '@/public/link.js'
export default {
  data () {
    return {
      jMarkId: '',
      inByLetDialogShow: false,
      typeData: []
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    isList: {
      type: Boolean
    }
  },
  created () {},
  mounted () {
    this.$forceUpdate()
  },
  components: {
    jPop: () => import('@/components/zhaocai/jPop'),
    InByLetDialog: () => import('@/components/zhaocai/InquiryLetterDialog')
  },
  methods: {
    async getTenderReceiverInquiry (type) {
      let pararms = {
        tenderingType: type
      }
      let { data } = await apiIln.getTenderReceiverInquiry(pararms)
      if (data.code === 0) {
        this.typeData = data.result
      }
    },
    // 函询dialog关闭方法
    closeinDialog (val) {
      this.inByLetDialogShow = val
    },
    async confirminDialog (obj, cab) {
      let data = { markId: this.jMarkId, ...obj }
      let res = await apiIln.getSaveForBid(data)
      if (res.data.code == 0) {
        this.$message.success(res.data.msg)
        this.inByLetDialogShow = false
      } else {
        this.$message.error(res.data.msg)
      }
      cab()
    },
    toCompany (no) {
      link.materialsShopUrl(no, 10)
    },
    goDetail (no, typeName) {
      window.open(process.env.VUE_APP_ZHAOCAI+'/CompeteBiddingDetail?no=' + no + '&typeName=' + typeName)
    },
    getMoney (val) {
      if (val >= 10000) {
        return (val / 10000).toString().match(/^\d+(?:\.\d{0,2})?/) + '万元'
      } else {
        return val + '元'
      }
    },
    // 函询
    async inByLetDialogClick (e, s, obj) {
      if (this.$store.state.loginType) {
        let res = {}
        if (s == 0) {
          res = await apiIln.getCheckAllowBidQuestion(e)
        } else {
          res = await apiIln.getCheckAllowTenderQuestion(e)
        }

        if (res.data.code == 0) {
          this.getTenderReceiverInquiry(obj.type)
          this.jMarkId = e
          this.inByLetDialogShow = true
        } else {
          this.$message.error(res.data.msg)
        }
      } else {
        // 没有登录
        this.$store.commit('SET_LOGINDIALOG', true)
        return false
      }
    },
    goNewDetail (no) {
      window.open(`${process.env.VUE_APP_ZHAOCAI}/CompeteBiddingDetail?no=${no}`)
    },
    showDetails (e, twoE, index, item = {}) {
      if (this.isList) {
        this.$emit('showDetails', e, twoE, index)
      } else {
        this.goNewDetail(item.id)
      }
    }
  },
  filters: {
    dealStatus (status) {
      // 招标状态
      let str = ''
      switch (status) {
        case 1:
          str = '待招标'
          break
        case 2:
          str = '招标中'
          break
        case 3:
          str = '评标中'
          break
        case 4:
          str = '招标结束'
          break
        case 5:
          str = '废标'
          break
        case 6:
          str = '评标中'
          break
        case 9:
          str = '报名中'
          break
        case 10:
          str = '资格审查中'
          break
        default:
          break
      }
      return str
    },
    direct (status) {
      let str = ''
      switch (status) {
        case 1:
          str = '草稿'
          break
        case 2:
          str = '竞价中'
          break
        case 3:
          str = '已结束'
          break
        case 4:
          str = '已取消'
          break
        default:
          break
      }
      return str
    },
    showStatus (status) {
      // 招标状态
      let str = ''
      switch (status) {
        case 3:
          str = '招标结束'
          break
        case 8:
          str = '待报名'
          break
        case 9:
          str = '报名中'
          break
        case 10:
          str = '资格审查中'
          break
        default:
          str = '招标中'
          break
      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.bidding {
  width: 275px;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  margin-left: 20px;
  margin-top: 20px;
  .bidding-list {
    float: left;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 275px;
    height: 214px;
    &:nth-child(even) {
      margin-right: 0;
    }
    .list-item {
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      height: 60px;
      background: #f5f7fa;
      position: relative;
      .item-top {
        display: flex;
        height: 120%;
        flex-direction: column;
        justify-content: center;
        font-size: 14px;
        position: relative;
        .leftBtn {
          position: absolute;
          right: -120px;
          z-index: 999;
        }
        .item-type {
          width: 400px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          display: flex;
          span {
            color: #ff6600;
            white-space: nowrap;
            flex: 1;
          }
          h4 {
            margin: 0;
            padding: 0;
            font-weight: normal;
            padding-left: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 340px;
          }
        }
        .company {
          padding-left: 6px;
          color: #666;
          line-height: 28px;
          width: 400px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
    .data-list {
      padding: 0 10px;
      height: 114px;
      overflow: hidden;
    }
    /deep/.data-list .el-table td {
      padding: 7px 0;
      border: 0;
    }
    /deep/.data-list .el-table th {
      padding: 7px 0;
      border: 0;
    }
    /deep/.el-table:before {
      height: 0;
    }
  }
}
.type_span {
  color: #ff6600;
  white-space: nowrap;
  flex: 1;
}
// .i-statusTitle {
//     display: block;
//     position: absolute;
//     top: 9px;
//     right: -25px;
//     font-size: 12px;
//     color: #fff;
//     background-color: #999;
//     width: 90px;
//     height: 24px;
//     line-height: 24px;
//     text-align: center;
//     transform: rotate(45deg);
//     transform-origin: (0, 0);
// }
.blue {
  background-color: #409ee9;
}
.end-time {
  color: #666;
  margin-top: 12px;
  font-size: 14px;
  span {
    color: #969696;
  }
}
.head {
  height: 59px;
  background-color: #f5f7fa;
  position: relative;
  border-bottom: 1px solid #e4e7ed;
  overflow: hidden;
  font-size: 12px;
  .title_name {
    display: inline-block;
    width: 200px;
    height: 50px;
    line-height: 25px;
    padding-top: 10px;
    margin-left: 10px;
    font-size: 14px;
    color: #333;
    font-weight: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .i-status {
    display: block;
    position: absolute;
    top: 37px;
    right: -15px;
    font-size: 12px;
    color: #0286df;
    width: 90px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    transform-origin: (0, 0);
  }
  .i-statusTitle {
    display: block;
    position: absolute;
    top: -8px;
    right: -10px;
  }
  .blue {
    background-color: #409ee9;
  }
}
</style>
